import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'

const GraphProductedPieces = ({ productedQuantity }) => {
  const [options, setOptions] = useState({
    options: {
      chart: {
        id: "basic-bar"
      },
      title: {
        text: 'Producted Pieces',
        align: 'center',
        style: {
          fontSize: '14px',
          color: '#444444'
        },
      },
      xaxis: {
        categories: [0,0,0,0,0,0],
        labels: {
          style: {
            colors: ['#3b3b3b'],
          }
        }
      },
      yaxis: {
        labels: {
          style: {
            colors: ['#414141'],
          }
        }
      }
    },
    series: [
      {
        name: "Producted Pieces",
        data: [0,0,0,0,0,0],
      }
    ]
  })

  useEffect(() => {
    if (Object.keys(productedQuantity).length === 0) return

    setOptions({
      options: {
        chart: {
          id: "basic-bar"
        },
        title: {
          text: 'Producted Pieces',
          align: 'center',
          style: {
            fontSize: '14px',
            color: '#444444'
          },
        },
        xaxis: {
          categories: productedQuantity.uniqueDays,
          labels: {
            style: {
              colors: productedQuantity?.uniqueDays?.map((u) => '#3b3b3b'),
            }
          }
        },
        yaxis: {
          labels: {
            style: {
              colors: productedQuantity?.quantity?.map((u) => '#414141'),
            }
          }
        }
      },
      series: [
        {
          name: "Producted Pieces",
          data: productedQuantity.quantity,
        }
      ]
    })
  }, [productedQuantity])

  return (
    <>
        <ReactApexChart
          options={options?.options}
          series={options?.series}
          type="area"
          className='w-full lg:p-2 '
          height={'280'} />
    </>
  )
}

export default GraphProductedPieces